module.exports = __webpack_public_path__ + "img/postcards4wa_logo.affb59e5.png";